import React, { memo, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { iFullStoreState } from '../../../../shared/interfaces';
import { fetchDevicesLatestPing } from '../../../../stores/reducers/devicesData/AC';
import { openDashboard } from '../../../../stores/reducers/dashboardInfo/AC';
import DashboardBlock from '../../../DashboardBlock';
import Loader from '../../Billing/Other/Loader';
import { ReportNavbar } from '../ReportNavbar';
import ExpirationsTable from './ExpirationsTable';
import { useExpirationsReport } from './hooks/useExpirationsReport';
import ModalHeaderComponent from '../../../menus/modal/modal-header';
import styles from './Expirations.module.scss';
import MinimalTile from '../../../general/MinimalTile';
import { exportExpirationReportXlsx } from './expiration-export';
import { Tooltip } from '@mui/material';
import { Fa } from '../../../elements/fa';
import { faFileExcel } from '@fortawesome/fontawesome-free-solid';

type FiltersType = {
    [type: string]: { [id: string]: true }
};

const ExpirationsReport = memo(() => {
    const dispatch = useDispatch();
    const filters = useSelector<iFullStoreState, FiltersType>(state => state.report.details.filters);

    const [filteredDeviceIds, setFilteredDeviceIds] = useState<string[]>([]);

    useEffect(() => {
        dispatch(fetchDevicesLatestPing());
        dispatch(openDashboard());
    }, [dispatch]);

    useEffect(() => {
        const deviceIds = filters['device'] ? Object.keys(filters['device']) : [];
        setFilteredDeviceIds(deviceIds);
    }, [filters]);

    const { reportData, loading } = useExpirationsReport(filteredDeviceIds);

    const hasData = reportData && (
        reportData.expired.length > 0 ||
        reportData.days30.length > 0 ||
        reportData.days60.length > 0 ||
        reportData.days90.length > 0
    );

    const handleExportXlsx = () => {
        if (!reportData) return;
        exportExpirationReportXlsx(reportData);
    };

    return (
        <DashboardBlock>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '12px', marginBottom: '12px', whiteSpace: 'nowrap' }}>
                <h2 style={{ margin: 0, fontSize: '18px', fontWeight: 600 }}>Expirations Report</h2>
                {hasData && !loading && (
                    <Tooltip title="Export as XLSX">
                        <button onClick={handleExportXlsx} className={styles.exportBtn}>
                            <Fa icon={faFileExcel} /> Export
                        </button>
                    </Tooltip>
                )}
            </div>
            <ReportNavbar />

            {loading ? (
                <Loader />
            ) : hasData ? (
                <div className={styles.reportContainer}>
                    <ExpirationsTable data={reportData!} />
                </div>
            ) : (
                <MinimalTile className={styles.minimalTile}>
                    <p>No expiring registrations found for the vehicles.</p>
                </MinimalTile>
            )}
        </DashboardBlock>
    );
});

export default ExpirationsReport;